/**
 * Preferred campus event keys.
 */
const PreferredCampusEvents = {
    /*
     * Updates a users preferred campus in the session.
     *
     * @payload String campus (e.g. "seattle")
     */
    updatePreferredCampus: "PreferredCampus.update",
};
export default PreferredCampusEvents;